module.exports = __webpack_public_path__ + "media/images/lb/774-3ef892090e40dcb7e1d2eb49b9c6a931.svg";